const Page = ({ id, children }) => 
    <article class="page" id={id}>
        <div class ="wrapper">
            {children}
        </div>
    </article>

export default Page;